import FlexPane from './_flex-pane.js'
import LoaderSuspense from './_loader-suspense.js'
import KeyValueMap from './_key-value-map.js'
import Swiper from './_swiper.js'
import EventCardsSkeleton from './_event-cards-skeleton.js'

export default {
  name: 'EventCardsCarousel',
  values: {
    locationId: 'event_cards',
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
      },
    },
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        showLoaderDelay: -1,
        style: {
          container: {
            maxWidth: '100%',
          },
          hidden: {
            display: 'block',
            width: '100%',
            position: 'absolute',
            visibility: 'hidden',
            opacity: 0,
            zIndex: -1,
          },
        },
      },
    },
    minCardsNumber: 3,
    reportLoadingStatus: false,
    cardRenderersByType: {
      configSet: KeyValueMap,
      configValues: {},
    },
    fallbackSportId: undefined,
    swiper: {
      configSet: Swiper,
      configValues: {
        lazyLoadBufferSize: 2,
        minViewableBufferSize: 3,
        _mobile_minViewableBufferSize: 2,
        postponedContentOptimization: true,
        style: {
          padding: '2px 1px',
          _mobile_padding: '2px 8px',
          gap: '8px',
          width: '100%',
          scrollPaddingLeft: '8px',
          scrollPaddingRight: '8px',
        },
        slide: {
          style: {
            minHeight: '152px',
            flexBasis: '294px',
          },
        },
      },
    },
    eventCardsSkeleton: {
      configSet: EventCardsSkeleton,
      configValues: {
        container: {
          style: {
            _mobile_padding: '0 8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
